<template>
  <div class="g-page">
    <div class="content-container">

      <!-- HEADER -->
      <div class="header-row">
        <h2 class="page-title">Qaytarilganlar</h2>
        <div class="header-actions">
          <div class="search-box">
            <b-icon icon="search" class="search-icon"></b-icon>
            <input v-model="searchText" type="text" placeholder="Mijoz / mahsulot / xizmat..." class="search-input" />
          </div>

          <!-- Sana oralig'i -->
          <div class="date-range">
            <input type="date" v-model="dateFrom" class="date-input" @change="fetchHistory" />
            <span class="date-sep">—</span>
            <input type="date" v-model="dateTo" class="date-input" @change="fetchHistory" />
          </div>

          <!-- Tur bo'yicha filter -->
          <div class="show-toggle">
            <button :class="['st-btn', sourceFilter === 'all' ? 'active' : '']" @click="sourceFilter = 'all'">
              <b-icon icon="collection"></b-icon> Hammasi
            </button>
            <button :class="['st-btn', sourceFilter === 'service_sale' ? 'active' : '']" @click="sourceFilter = 'service_sale'">
              <b-icon icon="gear"></b-icon> Xizmat-savdo
            </button>
            <button :class="['st-btn', sourceFilter === 'refund' ? 'active' : '']" @click="sourceFilter = 'refund'">
              <b-icon icon="box-seam"></b-icon> Qaytarish
            </button>
          </div>

          <div class="total-badge">
            Qaytgan summa: <b>{{ formatMoney(totalReturned) }} UZS</b>
          </div>
          <div class="total-badge count-badge">
            Soni: <b>{{ filteredHistory.length }}</b>
          </div>
        </div>
      </div>

      <!-- JADVAL -->
      <div class="table-card">
        <div class="table-wrapper">
          <table class="custom-table">
            <thead>
              <tr>
                <th style="width:50px">№</th>
                <th>SANA</th>
                <th>HUJJAT</th>
                <th>MIJOZ</th>
                <th>QAYTARILGANLAR</th>
                <th class="text-right">QAYTGAN SUMMA</th>
                <th>FOYDALANUVCHI</th>
                <th style="width:60px; text-align:center">AMAL</th>
              </tr>
            </thead>
            <tbody v-for="(item, index) in filteredHistory" :key="item.key">
              <tr :class="['clickable-row', { expanded: expandedKey === item.key }]" @click="toggleExpand(item.key)">
                <td><span class="id-badge">{{ index + 1 }}</span></td>
                <td>{{ formatDate(item.datetime) }}</td>
                <td>
                  <span :class="['tag', item.source === 'service_sale' ? 'svc-tag' : 'prod-tag']">
                    {{ item.source === 'service_sale' ? 'Xizmat-savdo' : 'Qaytarish' }}
                  </span>
                  <span class="doc-num">#{{ item.number }}</span>
                </td>
                <td><span class="font-bold text-dark">{{ item.kontragent_name || '-' }}</span></td>
                <td>
                  <span v-if="item.products.length" class="mini-tag blue-mini">
                    <b-icon icon="box-seam"></b-icon> {{ item.products.length }} mahsulot
                  </span>
                  <span v-if="item.services.length" class="mini-tag purple-mini">
                    <b-icon icon="gear"></b-icon> {{ item.services.length }} xizmat
                  </span>
                  <span v-if="item.exchange.length" class="mini-tag amber-mini">
                    <b-icon icon="arrow-left-right"></b-icon> {{ item.exchange.length }} almashtirish
                  </span>
                  <span v-if="!item.products.length && !item.services.length && !item.exchange.length" class="text-muted small">-</span>
                </td>
                <td class="text-right">
                  <div class="ret-amount">{{ formatMoney(item.total_return) }} <span class="currency">UZS</span></div>
                </td>
                <td><span class="text-muted small">{{ item.user_name || '-' }}</span></td>
                <td class="text-center">
                  <button class="eye-btn" :title="expandedKey === item.key ? 'Yopish' : 'Ko\'rish'">
                    <b-icon :icon="expandedKey === item.key ? 'eye-slash' : 'eye'"></b-icon>
                  </button>
                </td>
              </tr>

              <!-- KENGAYTIRILGAN -->
              <tr v-if="expandedKey === item.key" class="detail-row">
                <td colspan="8">
                  <div class="detail-container">
                    <!-- MAHSULOTLAR -->
                    <div v-if="item.products.length" class="detail-section">
                      <div class="detail-section-title blue">
                        <b-icon icon="box-seam" class="mr-1"></b-icon> Qaytarilgan mahsulotlar
                      </div>
                      <table class="inner-table">
                        <thead>
                          <tr>
                            <th>Nomi</th>
                            <th class="text-right">Soni</th>
                            <th class="text-right">Narxi</th>
                            <th class="text-right">Summasi</th>
                            <th class="text-center">Holati</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(p, i) in item.products" :key="'p-' + i">
                            <td>{{ p.name }}</td>
                            <td class="text-right">{{ p.count }}</td>
                            <td class="text-right">{{ formatMoney(p.price) }}</td>
                            <td class="text-right font-bold">{{ formatMoney(p.summa) }}</td>
                            <td class="text-center">
                              <span v-if="p.restock === false" class="tag red-tag">Brak</span>
                              <span v-else class="tag green-tag">Omborga</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- XIZMATLAR -->
                    <div v-if="item.services.length" class="detail-section">
                      <div class="detail-section-title purple">
                        <b-icon icon="gear" class="mr-1"></b-icon> Qaytarilgan xizmatlar
                      </div>
                      <table class="inner-table">
                        <thead>
                          <tr>
                            <th>Nomi</th>
                            <th class="text-right">Summasi</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(s, i) in item.services" :key="'s-' + i">
                            <td>{{ s.name }}</td>
                            <td class="text-right font-bold">{{ formatMoney(s.summa) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- ALMASHTIRISH -->
                    <div v-if="item.exchange.length" class="detail-section">
                      <div class="detail-section-title amber">
                        <b-icon icon="arrow-left-right" class="mr-1"></b-icon> Almashtirib berilgan (yangi mahsulot)
                      </div>
                      <table class="inner-table">
                        <thead>
                          <tr>
                            <th>Nomi</th>
                            <th class="text-right">Soni</th>
                            <th class="text-right">Summasi</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(e, i) in item.exchange" :key="'e-' + i">
                            <td>{{ e.name }}</td>
                            <td class="text-right">{{ e.count }}</td>
                            <td class="text-right font-bold">{{ formatMoney(e.summa) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- XULOSA -->
                    <div class="detail-summary">
                      <span>Qaytgan qiymat: <b class="blue">{{ formatMoney(item.total_return) }} UZS</b></span>
                      <span v-if="item.exchange_value > 0">Almashtirish: <b class="amber">{{ formatMoney(item.exchange_value) }} UZS</b></span>
                      <span v-if="item.exchange_value > 0">
                        Sof:
                        <b :class="item.net_to_customer >= 0 ? 'green' : 'red'">
                          {{ formatMoney(Math.abs(item.net_to_customer)) }} UZS
                          {{ item.net_to_customer >= 0 ? '(mijozga)' : '(mijozdan)' }}
                        </b>
                      </span>
                      <span v-if="item.comment" class="cmt">Izoh: {{ item.comment }}</span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>

            <tbody v-if="!loading && filteredHistory.length === 0">
              <tr>
                <td colspan="8" class="empty-row">
                  <div class="py-5 text-center">
                    <p class="text-muted">{{ searchText ? 'Qidiruv natijasi topilmadi' : 'Qaytarish topilmadi' }}</p>
                  </div>
                </td>
              </tr>
            </tbody>

            <tbody v-if="loading">
              <tr>
                <td colspan="8" class="text-center py-5">
                  <b-spinner variant="primary"></b-spinner>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'QaytarilganlarIndex',
  data() {
    return {
      loading: false,
      history: [],
      searchText: '',
      sourceFilter: 'all', // all | service_sale | refund
      dateFrom: '',
      dateTo: '',
      expandedKey: null,
    };
  },
  computed: {
    filteredHistory() {
      let list = this.history;
      if (this.sourceFilter !== 'all') {
        list = list.filter(h => h.source === this.sourceFilter);
      }
      const q = (this.searchText || '').toLowerCase().trim();
      if (!q) return list;
      return list.filter(h => {
        if ((h.kontragent_name || '').toLowerCase().includes(q)) return true;
        if (String(h.number || '').includes(q)) return true;
        if (h.products.some(p => (p.name || '').toLowerCase().includes(q))) return true;
        if (h.services.some(s => (s.name || '').toLowerCase().includes(q))) return true;
        if (h.exchange.some(e => (e.name || '').toLowerCase().includes(q))) return true;
        return false;
      });
    },
    totalReturned() {
      return this.filteredHistory.reduce((s, h) => s + Number(h.total_return || 0), 0);
    },
  },
  mounted() {
    this.fetchHistory();
  },
  methods: {
    async fetchHistory() {
      this.loading = true;
      try {
        const params = {};
        if (this.dateFrom) params.date1 = Math.floor(new Date(this.dateFrom + 'T00:00:00').getTime() / 1000);
        if (this.dateTo) params.date2 = Math.floor(new Date(this.dateTo + 'T23:59:59').getTime() / 1000);
        const res = await axios.get('api/v1/refund/history', { params });
        const list = Array.isArray(res.data) ? res.data : [];
        // Massivlar har doim mavjud bo'lsin (xavfsiz render uchun)
        this.history = list.map(h => ({
          ...h,
          products: Array.isArray(h.products) ? h.products : [],
          services: Array.isArray(h.services) ? h.services : [],
          exchange: Array.isArray(h.exchange) ? h.exchange : [],
        }));
      } catch (e) {
        console.error('Qaytarishlar tarixini yuklashda xato:', e);
        this.history = [];
      } finally {
        this.loading = false;
      }
    },
    toggleExpand(key) {
      this.expandedKey = this.expandedKey === key ? null : key;
    },
    formatMoney(v) {
      if (!v || v === 0) return '0';
      return Number(v).toLocaleString('ru-RU').replace(/ /g, ' ');
    },
    formatDate(ts) {
      if (!ts) return '-';
      return this.$formatDate(ts);
    },
  },
};
</script>

<style scoped>
.g-page {
  padding: 20px;
  background: #f8fafc;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.content-container {
  max-width: 1320px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.page-title {
  color: #7c3aed;
  font-weight: 800;
  font-size: 24px;
  margin: 0;
}
.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.search-box { position: relative; display: flex; align-items: center; }
.search-icon { position: absolute; left: 12px; color: #94a3b8; }
.search-input {
  height: 40px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 0 12px 0 36px;
  font-size: 14px;
  outline: none;
  background: white;
  width: 220px;
}

.date-range {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0 10px;
  height: 40px;
}
.date-input { border: none; outline: none; font-size: 13px; color: #334155; background: transparent; }
.date-sep { color: #94a3b8; }

.show-toggle {
  display: inline-flex;
  background: #f1f5f9;
  border-radius: 10px;
  padding: 3px;
  gap: 2px;
}
.st-btn {
  background: transparent;
  border: none;
  padding: 7px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: 0.2s;
  white-space: nowrap;
}
.st-btn:hover:not(.active) { color: #7c3aed; background: rgba(255, 255, 255, 0.6); }
.st-btn.active {
  background: white;
  color: #0f172a;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
}

.total-badge {
  background: #f5f3ff;
  color: #7c3aed;
  border: 1px solid #ddd6fe;
  border-radius: 12px;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 600;
}
.count-badge { background: #f1f5f9; color: #475569; border-color: #e2e8f0; }

.table-card {
  background: white;
  border-radius: 20px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.03);
  border: 1px solid #f1f5f9;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.table-wrapper { overflow-y: auto; flex-grow: 1; }

.custom-table { width: 100%; border-collapse: separate; border-spacing: 0; }
.custom-table th {
  position: sticky;
  top: 0;
  background: white;
  z-index: 5;
  padding: 14px 15px;
  color: #94a3b8;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  border-bottom: 1px solid #f1f5f9;
  text-align: left;
}
.custom-table td {
  padding: 14px 15px;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  font-size: 14px;
}

.id-badge {
  background: #f1f5f9;
  padding: 3px 8px;
  border-radius: 7px;
  font-weight: 700;
  color: #64748b;
  font-size: 12px;
}
.doc-num { margin-left: 6px; color: #94a3b8; font-weight: 700; font-size: 12px; }

.tag {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
}
.red-tag   { background: #fff1f2; color: #e11d48; }
.green-tag { background: #ecfdf5; color: #10b981; }
.svc-tag   { background: #f5f3ff; color: #7c3aed; }
.prod-tag  { background: #eff6ff; color: #2563eb; }

.mini-tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 7px;
  font-size: 11px;
  font-weight: 700;
  margin-right: 5px;
}
.blue-mini   { background: #eff6ff; color: #2563eb; }
.purple-mini { background: #f5f3ff; color: #7c3aed; }
.amber-mini  { background: #fffbeb; color: #b45309; }

.ret-amount { color: #7c3aed; font-weight: 800; font-size: 15px; }
.currency { font-size: 11px; font-weight: 500; color: #94a3b8; }

.text-muted { color: #94a3b8; }
.small { font-size: 12px; }
.font-bold { font-weight: 700; }
.text-dark { color: #1e293b; }
.text-right { text-align: right; }
.text-center { text-align: center; }
.blue { color: #2563eb; }
.green { color: #10b981; }
.red { color: #e11d48; }
.amber { color: #b45309; }

.clickable-row { cursor: pointer; transition: background 0.15s; }
.clickable-row:hover td { background: #faf5ff; }
.clickable-row.expanded td { background: #faf5ff; }

.eye-btn {
  width: 30px;
  height: 28px;
  border-radius: 6px;
  border: none;
  background: #f5f3ff;
  color: #7c3aed;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
}
.eye-btn:hover { background: #7c3aed; color: white; transform: scale(1.05); }

.detail-row td {
  background: #faf9ff;
  padding: 0 !important;
  border-bottom: 2px solid #e2e8f0;
}
.detail-container { padding: 14px 18px; }
.detail-section { margin-bottom: 14px; }
.detail-section:last-child { margin-bottom: 0; }
.detail-section-title {
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e2e8f0;
}
.detail-section-title.purple { color: #7c3aed; }
.detail-section-title.blue { color: #2563eb; }
.detail-section-title.amber { color: #b45309; }

.inner-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,0.03);
}
.inner-table thead th {
  background: #f1f5f9;
  padding: 8px 10px;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  text-align: left;
}
.inner-table tbody td {
  padding: 8px 10px;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
}
.inner-table tbody tr:last-child td { border-bottom: none; }

.detail-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  padding: 12px 14px;
  background: white;
  border-radius: 10px;
  border: 1px dashed #ddd6fe;
  font-size: 13px;
  color: #475569;
}
.detail-summary .cmt { color: #94a3b8; font-style: italic; }
</style>
